import { RouteRecordRaw } from 'vue-router';
import { FINANCE_ROUTES } from '@fsd/shared/constants/routes';

export const FinanceRoutes: RouteRecordRaw[] = [
  {
    name: FINANCE_ROUTES.PAYMENT_METHODS.NAME,
    path: FINANCE_ROUTES.PAYMENT_METHODS.PATH,
    component: () => import('@fsd/pages/finance/payment-methods/index.vue'),
    meta: {
      title: 'pageFinance.paymentMethods.title',
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.FINANCE_WITHDRAW.NAME,
    path: FINANCE_ROUTES.FINANCE_WITHDRAW.PATH,
    component: () => import('@fsd/pages/finance/withdraw/index.vue'),
    meta: {
      title: 'withdrawPage.title',
      verification: 'simple',
      verificationModalText: 'withdraw.verificationModal.text',
    },
  },
  {
    name: FINANCE_ROUTES.CREATE_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.CREATE_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/create-payment-method/index.vue'),
    meta: {
      title: 'paymentMethod.paymentSystemType',
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.CREATE_CARD_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.CREATE_CARD_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/card-payment-method/create/index.vue'),
    meta: {
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.UPDATE_CARD_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.UPDATE_CARD_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/card-payment-method/update/index.vue'),
    meta: {
      title: 'paymentMethod.applicationForConfirmation',
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.CREATE_CRYPTO_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.CREATE_CRYPTO_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/crypto-payment-method/create/index.vue'),
    meta: {
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.PAYMENT_METHODS_VERIFICATION.NAME,
    path: FINANCE_ROUTES.PAYMENT_METHODS_VERIFICATION.PATH,
    component: () => import('@fsd/pages/finance/payment-methods/verification/index.vue'),
    meta: {
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.CREATE_EPS_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.CREATE_EPS_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/eps-payment-method/create/index.vue'),
    meta: {
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.UPDATE_EPS_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.UPDATE_EPS_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/eps-payment-method/update/index.vue'),
    meta: {
      title: 'paymentMethod.applicationForConfirmation',
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.CREATE_EXCHANGER_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.CREATE_EXCHANGER_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/exchanger-payment-method/create/index.vue'),
    meta: {
      title: 'paymentMethod.requisites',
      verification: 'simple',
    },
  },
  {
    name: FINANCE_ROUTES.CREATE_BANK_PAYMENT_METHOD.NAME,
    path: FINANCE_ROUTES.CREATE_BANK_PAYMENT_METHOD.PATH,
    component: () => import('@fsd/pages/finance/bank-payment-method/create/index.vue'),
    meta: {
      title: 'paymentMethod.requisites',
      verification: 'simple',
    },
  },
];
